module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_prize"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.award))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.showHonor())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.experience))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.showHistory())
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1682f240","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeacherPrize.vue
// module id = 1213
// module chunks = 4